import {useEffect} from 'react';

import AnalyticsObserver from 'coreClasses/analytics/AnalyticsObserver';
import {IAnalyticsConfiguration} from 'coreClasses/analytics/IAnalytics';

import {useGeneralProvider} from 'brandComponents/_app-config/GeneralProvider';
import AnalyticsMgr from 'brandClasses/analytics/AnalyticsMgr';

/**
 * This hook enables brand analytics
 */
export default function useAnalytics() {
	const {managerRepository} = useGeneralProvider();

	useEffect(() => {
		const analyticsConfiguration: IAnalyticsConfiguration = managerRepository
			.getConfigurationsMgr()
			.get('analytics');

		const analyticsProviders = AnalyticsMgr.getAnalyticsProviders(analyticsConfiguration?.providers, managerRepository);

		if (analyticsProviders.length > 0) {
			const analyticsObserver = new AnalyticsObserver(analyticsProviders);
			const eventsMgr = managerRepository.getEventsMgr();

			eventsMgr.subscribe(analyticsObserver);
		}
	}, []);
}
